<!-- src/shared/BasicParagraphs.svelte
     v12 step 1 — 從 ArchieML freeform 陣列吐出的物件渲染
     用法:<BasicParagraphs sectionName="prologue" />
          <BasicParagraphs sectionName="epilogue" />
     吃 $ContentDataStore[sectionName] (= ArchieML [+xxx] 自由陣列輸出)
     支援的 type:text / subtitle / image / list / demarcation
     -->
<script>
  import ContentDataStore from '../stores/ContentDataStore.js'
  export let sectionName = ''

  $: data = $ContentDataStore?.[sectionName] || []
</script>

<div class="basic-p-container">
  {#each data as { type, value }}
    {#if type === 'text'}
      <!-- 支援 HTML 以便內嵌 <strong> 等 -->
      <p>{@html value}</p>
    {:else if type === 'subtitle'}
      <h3>{value}</h3>
    {:else if type === 'image'}
      <figure class="img-wrapper">
        <img src={value?.url} alt={value?.description || value?.discription || ''} />
        {#if value?.description || value?.discription || value?.note}
          <figcaption class="caption">{value.description || value.discription || value.note}</figcaption>
        {/if}
        {#if value?.credit}
          <div class="credit">{value.credit}</div>
        {/if}
      </figure>
    {:else if type === 'list'}
      <ul>
        {#each value.split('|') as item}
          <li>{item}</li>
        {/each}
      </ul>
    {:else if type === 'demarcation'}
      <hr />
    {/if}
  {/each}
</div>

<style>
  .basic-p-container {
    max-width: 680px;
    margin: 0 auto;
    padding: 6rem 2rem 3rem;
  }
  .basic-p-container > p {
    font-size: 1.05rem;
    line-height: 2.2;
    letter-spacing: 0.025em;
    margin-bottom: 1.8rem;
    color: var(--color-text, #222222);
    font-family: 'Noto Sans TC', sans-serif;
  }
  .basic-p-container :global(strong) {
    color: var(--color-accent, #d44545);
    font-weight: 600;
  }
  .basic-p-container :global(a) {
    color: var(--color-blue, #3e6a8a);
    text-decoration: underline;
  }
  .basic-p-container > h3 {
    font-size: 1.2rem;
    line-height: 1.8;
    letter-spacing: 0.1em;
    padding: 2rem 0 1rem;
    color: var(--color-text, #222222);
    font-weight: 600;
    font-family: 'Noto Sans TC', sans-serif;
  }
  .basic-p-container > ul {
    padding-left: 1.5rem;
    margin-bottom: 1.8rem;
    color: var(--color-text, #222222);
    line-height: 2;
  }
  .basic-p-container > ul > li {
    padding-bottom: 0.25rem;
  }
  .basic-p-container > .img-wrapper {
    padding-bottom: 1.5rem;
    margin: 2rem auto;
  }
  .basic-p-container > .img-wrapper > img {
    width: 100%;
    max-width: 680px;
    display: block;
    margin: 0 auto;
  }
  .caption {
    margin: 0.5rem 0;
    font-size: 0.85rem;
    color: var(--color-text-dim, #777777);
    text-align: center;
  }
  .credit {
    margin-top: 0.3rem;
    font-size: 0.75rem;
    color: var(--color-text-muted, #9aa5b0);
    text-align: center;
    letter-spacing: 0.05em;
  }
  hr {
    margin: 2rem auto;
    border: none;
    border-top: 1px solid #d0cdc6;
  }
</style>
